// Header fixed code
$(window).on('scroll resize load', function() {
  var headerHeight = $('#site-header .top').height();
  var windowPosition = $(window).scrollTop();

  if (windowPosition >= headerHeight) {
    $('#site-header').addClass('fixed');
  } else {
    $('#site-header').removeClass('fixed');
  }
});

var $animationElements = $('.animate-on-scroll');
var $window = $(window);

$animationElements.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('finished-animation');
});

function checkIfInView() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animationElements, function(index, element) {
    var $element = $(this);
    var elementHeight = $element.outerHeight();
    var elementHeightHalf = elementHeight / 4;
    var elementTopPosition = $element.offset().top;
    var elementBottomPosition = (elementTopPosition + elementHeight);
    var animationRunning = null;
    var animationName = $element.data('animation') || 'fadeInUp';
    var animationDelay = $element.data('animation-delay') || 125;

    if ($(this).hasClass('.animated')) {
      return false;
    }

    if ((elementBottomPosition >= window_top_position) &&
        (elementTopPosition <= window_bottom_position)) {
      animationRunning = setTimeout(function() {
          $element.addClass('animated ' + animationName);
        }, (index * animationDelay))
    }
  });
}

$window.on('scroll resize', checkIfInView);
